import React from 'react';
import classNames from 'classnames';

import { UiSpinner } from 'src/components/UI/Spinner';

type Props = {
  centered?: boolean;
  fullScreenCentered?: boolean;
  className?: string;
};

export const UiLoader: React.FC<Props> = ({ centered = false, fullScreenCentered = false, className }: Props) => {
  if (fullScreenCentered) {
    return (
      <div className={classNames('center display-inline-block position-absolute', className)}>
        <UiLoader />
      </div>
    );
  }
  if (centered) {
    return (
      <div className={classNames('text-center', className)}>
        <UiSpinner />
      </div>
    );
  }
  return <UiSpinner className={className} />;
};
